<template>
    <el-dialog :title="inputForm.ticketingServerName" :append-to-body="true" :fullscreen="true"
               :close-on-click-modal="false" :visible.sync="visible" v-if="visible">
        <el-form size="small" :model="inputForm" ref="inputForm" label-width="160px" :disabled="method == 0"
                 v-loading="loading">
            <div class="el-descriptions__title el-descriptions p_l1 p_b2">基本信息</div>
            <el-form-item label="服务名称：" prop="ticketingServerName">{{ inputForm.ticketingServerName }}
            </el-form-item>
            <el-form-item label="商品图片：" prop="imgList">
                <ImgUpload :imgAskObj="imgUploadRequire" @getImgList="getImgList" v-if="method == 1"></ImgUpload>
                <div class="imgList" @click="checkImage" v-else>
                    <el-image :src="item" fit="cover" v-for="(item, index) in inputForm.ticketingServerImage"
                              :key="index"
                              class="img" :preview-src-list="inputForm.ticketingServerImage"></el-image>
                </div>
            </el-form-item>
            <el-form-item label="商品视频：" prop="ticketingServerVideo">
                <el-col :span="8">
                    <ImgUpload :imgAskObj="videoUploadRequire" @getImgList="getVideoList"
                               v-if="method == 1"></ImgUpload>
                    <video controls :src="inputForm.ticketingServerVideo" class="w100" v-else></video>
                </el-col>
            </el-form-item>
            <el-form-item label="状态：" prop="ticketingServerState">
                <el-radio-group v-model="inputForm.ticketingServerState">
                    <el-radio label="0">启用</el-radio>
                    <el-radio label="1">禁用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="时长（小时）：" prop="ticketingServerHour">
                <el-input v-model="inputForm.ticketingServerHour" maxlength="2" placeholder="请输入时长（0-99）"
                          onkeyup="value=value.replace(/[^\d]/g,'')"
                          oninput="if(value>99)value=99;if(value<0)value=0" clearable style="width: 35.5%"></el-input>
            </el-form-item>
            <el-form-item label="适用范围：" prop="ticketingServerRange">
                <el-input v-model="inputForm.ticketingServerRange" maxlength="100" placeholder="请输入适用范围（限100字）"
                          clearable
                          style="width: 35.5%"></el-input>
            </el-form-item>

            <el-form-item label="超时处理：" prop="timeoutHandling">
                <div>
                    <el-radio v-model="inputForm.timeoutHandling" label="1">自动退<span class="handlingPrompts">过期后，系统自动全额退款。</span>
                    </el-radio>
                </div>
                <div>
                    <el-radio v-model="inputForm.timeoutHandling" label="2">手动退<span class="handlingPrompts">过期超过3天申请退款，系统将收取 10% 的手续费；否则，支持全额退款。</span>
                    </el-radio>
                </div>
            </el-form-item>

            <div v-if="method == 0">
                <el-form-item label="添加人：">{{ inputForm.createUser }}</el-form-item>
                <el-form-item label="添加日期：">{{ inputForm.createTime }}</el-form-item>
                <el-form-item label="最后修改时间：">{{ inputForm.updateTime }}</el-form-item>
            </div>
            <div class="el-descriptions__title el-descriptions p_l1 p_t2 p_b2 b_t">服务规格</div>
            <div class="specifications">
                <el-row class="text_center">
                    <el-col :span="2" class="p_all1 b_d">序号</el-col>
                    <el-col :span="6" class="p_all1 b_r b_t b_b" v-if="inputForm.ticketingServerName == '人工讲解'">
                        人数
                    </el-col>
                    <el-col :span="6" class="p_all1 b_r b_t b_b" v-if="inputForm.ticketingServerName == '刺绣服务'">
                        年龄
                    </el-col>
                    <el-col :span="6" class="p_all1 b_r b_t b_b">语言</el-col>
                    <el-col :span="7" class="p_all1 b_r b_t b_b">价格（元）</el-col>
                    <el-col :span="3" class="p_all1 b_r b_t b_b" v-if="method == 1">操作</el-col>
                </el-row>
                <el-row v-for="(item, index) in inputForm.ticketingServerSkuVoList" :key="index" class="text_center">
                    <el-col :span="2" class="b_r b_b b_l">
                        <el-form-item label-width="0">{{ index + 1 }}</el-form-item>
                    </el-col>
                    <el-col :span="6" class="b_r b_b" v-if="inputForm.ticketingServerName == '人工讲解'">
                        <el-form-item :prop="`ticketingServerSkuVoList.${index}.numberOfPeopleId`"
                                      :rules="[{required: true, message: '人数不能为空', trigger: 'change'}]"
                                      label-width="0">
                            <el-select v-if="item.isEdit" size="small" v-model="item.numberOfPeopleId"
                                       placeholder="请选择人数"
                                       style="width: 100%;">
                                <el-option
                                        v-for="item in peopleOpt"
                                        :key="item.id"
                                        :label="item.numberOfPeople"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                            <div v-else>{{ peopleOpt.filter(c => c.id == item.numberOfPeopleId)[0].numberOfPeople }}
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="b_r b_b" v-if="inputForm.ticketingServerName == '刺绣服务'">
                        <el-form-item :prop="`ticketingServerSkuVoList.${index}.ageId`"
                                      :rules="[{required: true, message: '年龄不能为空', trigger: 'change'}]"
                                      label-width="0">
                            <el-select v-if="item.isEdit" size="small" v-model="item.ageId" placeholder="请选择年龄"
                                       style="width: 100%;">
                                <el-option
                                        v-for="item in ageOpt"
                                        :key="item.id"
                                        :label="item.age"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                            <div v-else>{{ ageOpt.filter(c => c.id == item.ageId)[0].age }}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="b_r b_b">
                        <el-form-item :prop="`ticketingServerSkuVoList.${index}.languageId`"
                                      :rules="[{required: true, message: '语言不能为空', trigger: 'change'}]"
                                      label-width="0">
                            <el-select v-if="item.isEdit" size="small" v-model="item.languageId"
                                       placeholder="请选择语言"
                                       style="width: 100%;">
                                <el-option v-for="item in languageOpt"
                                           :key="item.id"
                                           :label="item.language"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                            <div v-else>{{ languageOpt.filter(c => c.id == item.languageId)[0].language }}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7" class="b_r b_b">
                        <el-form-item :prop="`ticketingServerSkuVoList.${index}.price`"
                                      :rules="[{required: true, message: '价格不能为空', trigger: 'blur'},{validator:validator.isPrice, trigger:'blur'}]"
                                      label-width="0">
                            <el-input v-if="item.isEdit" size="small" v-model="item.price" placeholder="请输入价格"
                                      maxlength="6" @input="priceChange(item)"
                                      style="width: 100%;"></el-input>
                            <div v-else>{{ item.price }}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3" class="operationItem b_r b_b" v-if="method == 1">
                        <el-button type="text" size="mini" @click="editSpecifications(item, index)">{{
                            item.isEdit ?
                                '完成' : '编辑'
                            }}
                        </el-button>
                        <el-button type="text" size="mini" @click="delSpecifications(index)">删除</el-button>
                    </el-col>
                </el-row>
                <div class="text_center p_t1">
                    <el-button size="small" type="primary" @click="addSpecifications()" v-if="method == 1">增加
                    </el-button>
                </div>
            </div>
        </el-form>
        <div class="el-descriptions__title el-descriptions p_l1 p_t2 p_b2">使用日期</div>
        <div v-if="method != 0">
            <el-form size="small" :model="inputForm" ref="inputFormBottom" label-width="160px"
                     :disabled="!defaultRuleEdit"
                     v-loading="loading">
                <div class="flex_l_t">
                    <el-popover
                            placement="top-start"
                            width="220"
                            trigger="hover"
                            content="默认规则修改后，立即生效">
                        <div slot="reference" class="text_right customizeTitle botesTitlr">默认库存数量规则</div>
                    </el-popover>
                    <div>
                        <div v-for="(item,index) in inputForm.dataTimeList" :key="index" class="flex_l_c">
                            <el-form-item label-width="0" :prop="`dataTimeList.${index}.startTime`"
                                          :rules="{required: true, message: '开始时段不能为空', trigger: 'change'}">
                                <el-time-picker v-if="defaultRuleEdit" value-format="HH:mm:ss"
                                                @focus="setstartTimeOptions(item)"
                                                format="HH:mm:ss" :picker-options="startTimeOptions"
                                                v-model="item.startTime" placeholder="开始时段" clearable
                                                style="width: 100%">
                                </el-time-picker>
                                <div v-else>{{ item.startTime }}</div>
                            </el-form-item>
                            <div class="formMiddleCont">~</div>
                            <el-form-item label-width="0" :prop="`dataTimeList.${index}.endTime`"
                                          :rules="{required: true, message: '结束时段不能为空', trigger: 'change'}"
                                          class="formMiddleRight">
                                <el-time-picker v-if="defaultRuleEdit" value-format="HH:mm:ss"
                                                @focus="setendTimeOptions(item)"
                                                format="HH:mm:ss" :picker-options="endTimeOptions"
                                                v-model="item.endTime" placeholder="结束时段" clearable
                                                style="width: 100%">
                                </el-time-picker>
                                <div v-else>{{ item.endTime }}</div>
                            </el-form-item>
                            <el-form-item label-width="0" :prop="`dataTimeList.${index}.specifications`"
                                          :rules="{required: true, message: '请选择规格', trigger: 'change'}"
                                          class="formMiddleRight">
                                <el-select v-if="defaultRuleEdit" v-model="item.specifications" placeholder="请选择规格"
                                           clearable>
                                    <el-option
                                            v-for="item in peopleOpt"
                                            :key="item.id"
                                            :label="item.numberOfPeople"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                                <div v-else>{{ item.specifications }}</div>
                            </el-form-item>
                            <el-form-item label-width="0" :prop="`dataTimeList.${index}.num`"
                                          :rules="{required: true, message: '请填写数量', trigger: 'blur'}"
                                          class="formMiddleRight">
                                <el-input v-if="defaultRuleEdit" v-model="item.num" clearable
                                          placeholder="请填写数量"></el-input>
                                <div v-else>{{ item.num }}</div>
                            </el-form-item>
                            <div v-if="defaultRuleEdit" style="margin-bottom: 18px">
                                <el-button size="mini" type="danger" @click="deleteDataTimeList(item,index,'default')">
                                    删除
                                </el-button>
                            </div>
                        </div>
                        <div class="promptText">修改数据时，已购买的数量作为一个单独的数据仓存储。已预约数据保持不变</div>
                        <el-button v-if="defaultRuleEdit" icon="el-icon-plus" size="small" type="primary"
                                   @click="addDataTimeList('default')">
                            添加规则
                        </el-button>
                    </div>
                </div>
            </el-form>
            <div style="margin-top: 20px;margin-left: 160px">
                <div v-if="defaultRuleEdit">
                    <el-button size="small" type="primary" v-noMoreClick @click="submitDefaultRule()">提交
                    </el-button>
                    <el-button size="small" @click="closeDefaultRulesDay()">取消
                    </el-button>
                </div>
                <el-button v-else size="small" type="primary"
                           @click="defaultRuleEdit = !defaultRuleEdit">编辑
                </el-button>
            </div>
        </div>
        <div class="flex_l_t butTop">
            <div v-if="method != 0" class="text_right botesTitlr">自定义库存数量规则</div>
            <div class="flex_1" id="reservationSetting">
                <el-row :gutter="20" class="customRules">
                    <el-col :span="10">
                        <el-calendar v-model="customRulesVal">
                            <template slot="dateCell" slot-scope="{date, data}">
                                <div @click.stop="chooseCustomRulesDay(data)"
                                     class="dayItem">
                                    <div>{{ data.day.split('-').slice(2)[0] }}</div>
                                    <div v-for="(item, index) in formatCustomRules(data, 0)" :key="index">
                                        <div class="dayVotesNum" v-show="data.type == 'current-month'">
                                            {{ item.outTicketing }}/{{ item.countTicketing }}
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </el-calendar>
                    </el-col>
                    <el-col :span="14" v-show="showCustomRules">
                        <div>
                            <el-form size="small" :model="quantityRules" ref="quantityRules" label-width="120px"
                                     class="ticketsRulesBox p_t2" :disabled="customRulesIsEdit">
                                <el-form-item label="放票规则：" prop="checkOperate">
                                    <el-radio-group v-model="quantityRules.checkOperate"
                                                    @input="checkOperateChange">
                                        <el-radio label="0">默认</el-radio>
                                        <el-radio label="1">自定义</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="设置日期：" prop="belongToDay"
                                              :rules="[{required: true, message: '日期不能为空', trigger: 'change'}]">
                                    <el-date-picker v-if="!customRulesIsEdit"
                                                    v-model="quantityRules.belongToDay"
                                                    :picker-options="pickerOptions"
                                                    type="daterange"
                                                    value-format="yyyy-MM-dd"
                                                    format="yyyy-MM-dd"
                                                    range-separator="至"
                                                    start-placeholder="开始日期"
                                                    end-placeholder="结束日期">
                                    </el-date-picker>
                                    <div v-else>{{ quantityRules.belongToDay[0] }} ~
                                        {{ quantityRules.belongToDay[1] }}
                                    </div>
                                </el-form-item>
                                <div v-if="quantityRules.checkOperate == 1" class="flex_l_t">
                                    <div class="text_right botesTitlr botesTitlr2">库存数量：</div>
                                    <div class="flex_1">
                                        <div v-for="(item,index) in quantityRules.dataTimeList" :key="index"
                                             class="flex_l_c" style="margin-left: 10px">
                                            <el-form-item label-width="0" :prop="`dataTimeList.${index}.startTime`"
                                                          :rules="{required: true, message: '开始时段不能为空', trigger: 'change'}">
                                                <el-time-picker v-if="!customRulesIsEdit" value-format="HH:mm:ss"
                                                                @focus="setstartTimeOptions(item)"
                                                                format="HH:mm:ss" :picker-options="startTimeOptions"
                                                                v-model="item.startTime" placeholder="开始时段"
                                                                clearable
                                                                style="width: 100%">
                                                </el-time-picker>
                                                <div v-else>{{ item.startTime }}</div>
                                            </el-form-item>
                                            <div class="formMiddleCont">~</div>
                                            <el-form-item label-width="0" :prop="`dataTimeList.${index}.endTime`"
                                                          :rules="{required: true, message: '结束时段不能为空', trigger: 'change'}"
                                                          class="formMiddleRight">
                                                <el-time-picker v-if="!customRulesIsEdit" value-format="HH:mm:ss"
                                                                @focus="setendTimeOptions(item)"
                                                                format="HH:mm:ss" :picker-options="endTimeOptions"
                                                                v-model="item.endTime" placeholder="结束时段" clearable
                                                                style="width: 100%">
                                                </el-time-picker>
                                                <div v-else>{{ item.endTime }}</div>
                                            </el-form-item>
                                            <el-form-item label-width="0" :prop="`dataTimeList.${index}.specifications`"
                                                          :rules="{required: true, message: '请选择规格', trigger: 'change'}"
                                                          class="formMiddleRight">
                                                <el-select v-if="!customRulesIsEdit" v-model="item.specifications"
                                                           placeholder="请选择规格"
                                                           clearable>
                                                    <el-option
                                                            v-for="item in peopleOpt"
                                                            :key="item.id"
                                                            :label="item.numberOfPeople"
                                                            :value="item.id">
                                                    </el-option>
                                                </el-select>
                                                <div v-else>{{ item.specifications }}</div>
                                            </el-form-item>
                                            <el-form-item label-width="0" :prop="`dataTimeList.${index}.num`"
                                                          :rules="{required: true, message: '请填写数量', trigger: 'blur'}"
                                                          class="formMiddleRight">
                                                <el-input v-if="!customRulesIsEdit" v-model="item.num" clearable
                                                          placeholder="请填写数量"></el-input>
                                                <div v-else>{{ item.num }}(库存数)</div>
                                            </el-form-item>
                                            <div v-if="!customRulesIsEdit" style="margin-bottom: 18px">
                                                <el-button size="mini" type="danger"
                                                           @click="deleteDataTimeList(item,index,'customize')">
                                                    删除
                                                </el-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="!customRulesIsEdit" class="text_center">
                                    <el-button size="mini" type="primary" @click="addDataTimeList('customize')">
                                        添加
                                    </el-button>
                                </div>
                            </el-form>
                            <div v-if="method != 0" style="margin-left: 25%">
                                <div v-if="!customRulesIsEdit">
                                    <el-button size="small" type="primary" v-noMoreClick @click="submitRule()">提交
                                    </el-button>
                                    <el-button size="small" @click="chooseCustomRulesDay(customRulesVal)">取消
                                    </el-button>
                                </div>
                                <el-button v-else size="small" type="primary"
                                           @click="customRulesIsEdit = !customRulesIsEdit">编辑
                                </el-button>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div slot="footer" class="dialog-footer text_center">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="affirm()" v-noMoreClick v-if="method == 1">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import ImgUpload from "@/components/imgUpload/imgUpload";

export default {
    components: {ImgUpload},
    data() {
        return {
            visible: false,
            loading: false,
            method: 0,
            row: {},
            inputForm: {},
            peopleOpt: [],
            ageOpt: [],
            languageOpt: [],
            videoUploadRequire: {
                btnName: '上传视频', // 按钮名称
                imgCount: 1, // 上传数量 0表示不限制数量
                imgList: [], // 已上传的文件
                uploadPath: "course",
                fileType: ['mp4'], // 上传文件类型
                listType: 'text', // 图片缩略图类型
                imgNum: 5, // 上传文件兆数 0表示不限兆数
                fileTypeMark: 2, // 上传文件类型标识 1：图片；2：视频
            },
            imgUploadRequire: {
                imgCount: 9, // 上传数量 0表示不限制数量
                imgList: [], // 已上传的文件
                uploadPath: "course",
                imgSize: '750*750', // 图片尺寸
                listType: 'picture-card', // 图片缩略图类型
                imgNum: 1, // 上传文件兆数 0表示不限兆数
            },
            // 开始时间
            startTimeOptions: {
                selectableRange: `00:00:00-23:59:59`,
            },
            // 结束时间
            endTimeOptions: {
                selectableRange: `00:00:00-23:59:59`,
            },

            defaultRuleEdit: false,//默认库存数量规则是否编辑
            //库存数量规则
            customRulesVal: new Date(),
            customRules: [],
            limitPrev: new Date('2022-11-01'),  // 上个月最大限制
            showCustomRules: false,//是否展示规则
            // 放票规则
            pickerOptions: {
                disabledDate(v) {
                    return v.getTime() < new Date().getTime() - 86400000;//  - 86400000是否包括当天
                }
            },
            customRulesIsEdit: true,//是否禁用自定义规则输入框
            quantityRules: {
                checkOperate: '0',
                belongToDay: [],
                dataTimeList: [
                    {
                        startTime: null,
                        endTime: null,
                        specifications: null,
                        num: null,
                    },
                ],
            },
        }
    },
    computed: {
        formatCustomRules() {
            return data => {
                return this.customRules.filter(item => {
                    let time = item.belongToDay;
                    return time == data.day;
                });
            };
        },
    },
    methods: {
        // 初始化 row：数据；method：方法 0查看；1编辑
        init(id, method) {
            this.defaultRuleEdit = false
            this.customRulesIsEdit = true
            this.videoUploadRequire.imgList = []
            this.imgUploadRequire.imgList = []
            this.inputForm = {}
            this.method = method
            this.visible = true
            this.allNumberOfPeople();
            this.allAge();
            this.allLanguage();
            this.sysGetTicketingServerById(id);

            this.$nextTick(() => {
                this.listenerCustomRulesMonth() // 监听月份选择
            })
            this.getDefaultRulesMonthTicket(this.customRulesVal)//获取日历
        },
        // 获取服务详情
        sysGetTicketingServerById(id) {
            this.$axios(this.api.order.sysGetTicketingServerById, {ticketingServerId: id}).then((res) => {
                if (res.status) {
                    this.inputForm = res.data
                    this.inputForm.ticketingServerSkuVoList.map(item => {
                        this.$set(item, 'isEdit', false)
                    })
                    if (res.data.ticketingServerVideo != '') {
                        this.videoUploadRequire.imgList = [{
                            name: '商品视频',
                            url: res.data.ticketingServerVideo
                        }]
                    }
                    this.inputForm.ticketingServerImage.map(item => {
                        this.imgUploadRequire.imgList.push({
                            url: item
                        })
                    })


                    this.$set(this.inputForm, 'dataTimeList',
                        [
                            {
                                startTime: null,
                                endTime: null,
                                specifications: null,
                                num: null,
                            },
                        ]
                    )


                } else {
                    this.$message.error('查询失败');
                }
            })
        },
        // 获取人数配置
        allNumberOfPeople() {
            this.$axios(this.api.order.allNumberOfPeople).then((res) => {
                if (res.status) {
                    this.peopleOpt = res.data
                }
            })
        },
        // 获取年龄配置
        allAge() {
            this.$axios(this.api.order.allAge).then((res) => {
                if (res.status) {
                    this.ageOpt = res.data
                }
            })
        },
        // 获取语言配置
        allLanguage() {
            this.$axios(this.api.order.allLanguage).then((res) => {
                if (res.status) {
                    this.languageOpt = res.data
                }
            })
        },
        // 增加规格
        addSpecifications() {
            this.$refs['inputForm'].validate((valid) => {
                if (valid) {
                    /*this.inputForm.ticketingServerSkuVoList.map(item => {
                        this.$set(item, 'isEdit', false)
                    })*/
                    this.inputForm.ticketingServerSkuVoList.push({
                        numberOfPeopleId: null,
                        ageId: null,
                        languageId: null,
                        price: null,
                        isEdit: true,
                    })
                }
            })
        },
        // 编辑规格
        editSpecifications(item, index) {
            if (item.isEdit) {
                if (item.numberOfPeopleId == null && this.inputForm.ticketingServerName == '人工讲解') {
                    this.$message('请选择人数');
                    return false
                }
                if (item.ageId == null && this.inputForm.ticketingServerName == '刺绣服务') {
                    this.$message('请选择年龄');
                    return false
                }
                if (item.languageId == null) {
                    this.$message('请选择语言');
                    return false
                }
                if (item.price == null || item.price == '') {
                    this.$message('请输入价格');
                    return false
                }
                let reapetS = this.inputForm.ticketingServerSkuVoList.filter((itemL) => {
                    if (itemL.numberOfPeopleId == item.numberOfPeopleId && itemL.languageId == item.languageId) {
                        return item
                    }
                })
                if (reapetS.length >= 2) {
                    this.$message('已有该规则，请重新设置');
                    return false
                }
                if (!this.validate.isPrice(item.price)) {
                    return false
                }
                this.$set(this.inputForm.ticketingServerSkuVoList[index], 'isEdit', !item.isEdit)
            } else {
                this.$set(this.inputForm.ticketingServerSkuVoList[index], 'isEdit', !item.isEdit)
            }
        },
        // 删除规格
        delSpecifications(index) {
            this.$confirm(`确定删除这条数据吗?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.inputForm.ticketingServerSkuVoList.splice(index, 1);
            });
        },
        // 价格修改
        priceChange(item) {
            let value = item.price.replace(/[^\d^\.]+/g, '')
            if (value > 500) {
                this.$set(item, 'price', 500)
            } else {
                this.$set(item, 'price', value)
            }
        },
        // 确认
        affirm() {
            let isEditFlag = 0
            if (this.inputForm.ticketingServerSkuVoList.length == 0) {
                this.$message('请增加服务规格');
                return
            }
            this.$refs['inputForm'].validate((valid) => {
                if (valid) {
                    let ticketingServerSkuDtoList = [];
                    let p = JSON.parse(JSON.stringify(this.inputForm).replace(/ticketingServerSkuVoList/g, "ticketingServerSkuDtoList"))
                    p.ticketingServerSkuDtoList.map(item => {
                        ticketingServerSkuDtoList.push({
                            ageId: item.ageId,
                            languageId: item.languageId,
                            numberOfPeopleId: item.numberOfPeopleId,
                            price: item.price,
                        })
                        if (item.isEdit) {
                            isEditFlag++
                        }
                    })
                    if (isEditFlag > 0) {
                        this.$message('请完成服务规格');
                        isEditFlag = 0
                        return
                    }
                    this.loading = true;
                    p.ticketingServerSkuDtoList = ticketingServerSkuDtoList
                    this.$axios(this.api.order.sysSaveTicketingServer, p, 'post').then((res) => {
                        if (res.status) {
                            this.$message.success('提交成功');
                            this.loading = false;
                            this.visible = false;
                            this.$emit('refreshDataList')
                        } else {
                            this.$message.error(res.msg);
                            this.loading = false;
                        }
                    })
                }
            })
        },
        // 点击图片预览添加下载按钮
        checkImage() {
            let a = document.querySelector('.el-image-viewer__actions__inner');
            $(a).append(`<i class="el-icon-download"></i>`)
            $(".el-icon-download").click(function () {
                let imgsrc = document.querySelector('.el-image-viewer__img').src, name = 'photo'
                let image = new Image();
                // 解决跨域 Canvas 污染问题
                image.setAttribute("crossOrigin", "anonymous");
                image.onload = function () {
                    let canvas = document.createElement("canvas");
                    canvas.width = image.width;
                    canvas.height = image.height;
                    let context = canvas.getContext("2d");
                    context.drawImage(image, 0, 0, image.width, image.height);
                    let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
                    let a = document.createElement("a"); // 生成一个a元素
                    let event = new MouseEvent("click"); // 创建一个单击事件
                    a.download = name; // 设置图片名称
                    a.href = url; // 将生成的URL设置为a.href属性
                    a.dispatchEvent(event); // 触发a的单击事件
                };
                image.src = imgsrc;
            });
        },
        // 获取上传图片数据
        getImgList(data) {
            this.inputForm.ticketingServerImage = []
            data.map(item => {
                this.inputForm.ticketingServerImage.push(item.imgUrl)
            })
        },
        // 获取上传视频数据
        getVideoList(data) {
            if (data.length > 0) {
                this.inputForm.ticketingServerVideo = data[0].imgUrl
            } else {
                this.inputForm.ticketingServerVideo = ''
            }
        },

        //设置开始时间和结束时间的时间选择范围
        setstartTimeOptions(item) {
            this.startTimeOptions = {
                selectableRange: `00:00:00-${item.endTime ? item.endTime : '23:59:59'}`
            }
        },
        setendTimeOptions(item) {
            this.endTimeOptions = {
                selectableRange: `${item.startTime ? item.startTime : '00:00:00'}-'23:59:59'`
            }
        },

        //提交默认规则
        submitDefaultRule() {
            this.$refs.inputFormBottom.validate((valid) => {
                if (valid) {
                    console.log('提交')
                }
            });
        },

        //取消默认规则
        closeDefaultRulesDay() {
            this.$refs.inputFormBottom.resetFields()
            this.defaultRuleEdit = false
        },

        //添加数量规则
        addDataTimeList(type) {
            if (type == 'default') {
                //默认规则添加
                this.inputForm.dataTimeList.push({
                    startTime: null,
                    endTime: null,
                    specifications: null,
                    num: null,
                },)
            } else {
                //自定义规则添加
                this.quantityRules.dataTimeList.push({
                    startTime: null,
                    endTime: null,
                    specifications: null,
                    num: null,
                },)
            }
        },

        deleteDataTimeList(item, index, type) {
            this.$confirm('此操作将永久删除该规则, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (type == 'default') {
                    this.inputForm.dataTimeList.splice(index, 1)
                } else {
                    this.quantityRules.dataTimeList.splice(index, 1)
                }
            })
        },

        // 指定月份获取票仓数据
        getDefaultRulesMonthTicket(val) {
            let dayStr = this.common.formatMonthDate(val)
            this.$axios(this.api.order.getByYearsTicketingStorehouse, {dayStr}).then((res) => {
                if (res.status) {
                    this.customRules = res.data
                }
            })
        },

        // 选择自定义库存数量规则-天
        chooseCustomRulesDay(date) {
            this.customRulesVal = new Date(date.day)
            this.showCustomRules = true;
            this.customRulesIsEdit = true
            this.$refs.quantityRules.resetFields();
            // this.customRulesIsEdit = false;
            // this.$axios(this.api.order.getByDayTicketingStorehouse, {belongToDay: date.day}).then((res) => {
            //     if (res.status) {
            //         if (res.data) {
            //             this.customRulesForm = res.data
            //             this.$set(this.customRulesForm, 'belongToDay', [this.customRulesForm.belongToDay, this.customRulesForm.belongToDay])
            //             this.customRulesForm.ticketingStorehouseDetailVoList.map((item) => {
            //                 this.$set(item, 'storehouseStartTime', item.storehouseStartTime.slice(0, item.storehouseStartTime.lastIndexOf(":")))
            //                 this.$set(item, 'storehouseEndTime', item.storehouseEndTime.slice(0, item.storehouseEndTime.lastIndexOf(":")))
            //             })
            //             this.showCustomRules = true;
            //         } else {
            //             // 选择日期小于今天
            //             if (new Date(date.day) < new Date()) {
            //                 this.$message('没有历史数据哦');
            //             } else {
            //                 this.customRulesForm = {
            //                     checkOperate: '0',
            //                     belongToDay: [date.day, date.day],
            //                     ticketingStorehouseDetailVoList: [],
            //                 }
            //                 this.showCustomRules = true;
            //             }
            //         }
            //     }
            // })
        },


        // 监听自定义放票规则月份选择
        listenerCustomRulesMonth() {
            let that = this;
            let newHandle = function (e, type) {
                e.stopPropagation();
                if (that.customRulesVal <= that.limitPrev) {
                    $('.el-button--mini:first-child').attr('disabled', true)
                    that.$message('到达历史数据上限');
                    return false
                } else {
                    $('.el-button--mini:first-child').attr('disabled', false)
                }
                that.getDefaultRulesMonthTicket(that.customRulesVal)
            };
            $(".el-button--mini:not(:first-child):not(:last-child) span").html("当月")
            //自定义放票规则按钮
            $('.customRules .el-button--mini:first-child, .customRules .el-button--mini:not(:first-child):not(:last-child), .customRules .el-button--mini:last-child').click(function (e) {
                newHandle(e, 0);
            })
        },

        // 切换默认、自定义
        checkOperateChange(data) {
            console.log('切换规则')

            // if (data == 1 && this.customRulesForm.ticketingStorehouseDetailVoList.length == 0) {
            //     this.addCustomRulesItem()
            // }
        },

        //提交规则
        submitRule() {
            this.$refs.quantityRules.validate((valid) => {
                if (valid) {
                    console.log('提交')
                }
            });
        },


    },
}
</script>

<style lang="scss" scoped>
.specifications::v-deep .el-form-item--small.el-form-item {
  width: 80% !important;
  margin: 18px auto;
}

.operationItem {
  line-height: 32px;
  padding: 18px 0;
}

.imgList .img {
  margin-right: 10px;
  width: 10%;
}

.handlingPrompts {
  margin-left: 10px;
  font-size: 12px;
  color: rgb(189, 170, 170);
}

.botesTitlr {
  width: 160px;
  padding-top: 5px;
  padding-right: 18px;
  margin-right: 15px;
  box-sizing: border-box;
}

.botesTitlr2 {
  width: 110px;
  padding: 5px 0 0;
  margin: 0;
}

.customizeTitle {
  position: relative;
  cursor: pointer;

  &::after {
    position: absolute;
    content: '?';
    font-size: 10px;
    width: 13px;
    height: 13px;
    text-align: center;
    line-height: 15px;
    border-radius: 50%;
    border: 1px solid rgb(189, 170, 170);
    top: 63%;
    right: 0;
    transform: translateY(-50%);
  }
}

.formMiddleCont {
  margin-bottom: 18px;
  width: 25px;
  text-align: center;
}

.formMiddleRight {
  margin-right: 15px;
}

.butTop {
  margin-top: 20px;
}

.inventoryRules div {
  width: 50%;
}

.promptText {
  font-size: 12px;
  color: #8c939d;
  margin-bottom: 15px;
}
</style>
